angular.module("ainapp")
    .controller("assetsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Asset";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            MainService.VATsInDropdown().then(function (response) {
                $scope.Vats = response.data;
            });

            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            });

            MainService.CountriesInDropdown().then(function (response) {
                $scope.Countries = response.data;
            });

            $scope.Categories = [];
            MainService.ProductsParentList("Asset").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.CurrentTransProduct.CategoryId, "Asset").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                $scope.Branches = response.data;
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.branchSelectFun = function () {

                $scope.branchSelectDataSource = {
                    serverFiltering: true,
                    transport: {
                        read: function (o) {
                            o.success({
                                Data: $scope.Branches
                            });
                        }
                    },
                    schema: {
                        data: "Data"
                    },
                    pageSize: 10
                };

                $scope.selectBranchOptions = {
                    placeholder: "Select Branch...",
                    dataTextField: "Name",
                    dataValueField: "Id",
                    valuePrimitive: true,
                    autoBind: true,
                    dataSource: $scope.branchSelectDataSource
                };
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Product").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.Init = function () {

                $scope.CurrentTransProduct = {
                    Name: "",
                    NameAr: "",
                    ProductCode: "",
                    ParentId: "",
                    IsActive: true,
                    IsGroup: true,
                    Level: 3,
                    ProductType: "Asset",
                    BarCode: "",
                    Specification: "",
                    Model: "",
                    Description: "",
                    SupplierName: "",
                    DepreciationYear: "",
                    AMCCompany: "",
                    SellPrice: 0,
                    PurchasePrice: 0,
                    WarrantyDate: "",
                    UnitId: "",
                    CountryId: "",
                    VATId: "",
                    SalesAccountId: "",
                    PurchaseAccountId: "",
                    VatType: "Exclusive",
                    Image: "",
                    CategoryId: "",
                    BranchIds: [],
                }
                $scope.CurrentTransProduct.VATId = $scope.CompanyProfile.DefaultVATId;

                $scope.load = false;
                $scope.ViewVal = 0;

                $scope.selectedGroup = {};

                if ($stateParams.ItemId > 0) {
                    MainService.ProductById($stateParams.ItemId).then(function (response) {
                        $scope.CurrentTransProduct = response.data;

                        $scope.CurrentTransProduct.BranchIds = [];
                        angular.forEach($scope.CurrentTransProduct.ProductBranchs, function (e) {
                            $scope.CurrentTransProduct.BranchIds.push(e.BranchId);
                        })

                        $scope.branchSelectFun();

                        $scope.GetSub();
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("Network Error");
                    });
                } else {
                    $scope.branchSelectFun();
                }

            }
            $scope.Init();



            $scope.handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage = evt.target.result;
                        $scope.CurrentTransProduct.Image = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };

            $scope.handleFileSelect2 = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage2 = evt.target.result;
                        $scope.CurrentProduct.Image = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.PurchaseAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.PurchaseAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.SalesAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.SalesAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.CogsAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.COGSAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.InventoryAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.InventoryAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.addTransProduct = function () {

                if ($scope.CurrentTransProduct.Name == "") {
                    toastr.warning("Give Name");
                } else if ($scope.CurrentTransProduct.ProductCode == "") {
                    toastr.warning("Give Code");
                } else if ($scope.CurrentTransProduct.VATId == "") {
                    toastr.warning("Select VAT");
                } else if ($scope.CurrentTransProduct.UnitId == "") {
                    toastr.warning("Select Unit");
                } else {

                    $scope.CurrentTransProduct.ProductBranchs = [];
                    angular.forEach($scope.CurrentTransProduct.BranchIds, function (e) {
                        var tt = {
                            BranchId: e,
                        }
                        $scope.CurrentTransProduct.ProductBranchs.push(tt);
                    })

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddProduct($scope.CurrentTransProduct).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Saved");
                            if ($scope.CurrentTransProduct.Id > 0) {
                                $state.go("AssetList");
                            }
                            $scope.Init();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });
                }
            }



        }])
